import { erpAxios } from '.';

const loanMatrix = async (data) => {
  const result = await erpAxios.get(`/loanMatrix`, { params: { data: data } });
  return result.data;
};

export default loanMatrix;
